function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 91 94"
}, props), React.createElement("path", {
  d: "M12.342 88.915c0-3.35-.062-8.196.27-11.934.242-2.772 3.446-3.82 5.023-1.648a57.119 57.119 0 003.3 4.132C32.37 92.553 50.462 95.95 64.824 87.001c19.15-11.934 23.259-38.368 23.259-38.368 3.819-21.11-5.182-32.39-10.571-36.105-2.65-1.823-5.77-2.75-8.897-2.582-5.721.319-8.129 4.185-9.118 7.9-.747 2.81-4.248 3.152-5.403.508-1.868-4.291-2.961-9.396-2.961-15.017V2",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M18.604 45.26v11.288c0 1.921.996 3.668 2.56 4.542 3.078 1.724 6.025 2.962 8.592 3.684 10.723 3.031 19.792-4.003 20.816-15.055.768-8.25-3.12-15.626-3.12-15.626C40.728 20.3 40.5 6.975 40.5 6.975V2.007M2 88.915V74.528c0-6.799 3.812-10.939 6.254-12.898 1.245-.995 2.006-2.568 2.006-4.262V45.252",
  stroke: "#357287",
  strokeWidth: "3",
  strokeMiterlimit: "10",
  strokeLinecap: "round"
}), React.createElement("path", {
  d: "M79.034 63.37c3.791-8.227 4.981-15.368 5.002-15.505v-.053l.02-.06c3.972-21.953-7.416-30.507-8.723-31.41-1.799-1.239-3.909-1.915-5.978-1.915-.18 0-.352 0-.532.016-2.774.151-4.352 1.412-5.217 4.132 9.063 5.006 16.84 17.653 15.435 44.794h-.007z",
  fill: "#357287"
})));